import { combineReducers } from "redux";

import general from "./general";
import move from "./select/manual/move";
import values from "./values";

const reducer = combineReducers({
    general,
    values,
    move,
});

export default reducer;
